import { INotification } from "@modules/notifications/model/INotifications";

import { NotificationTabKey } from "../../model";
import { buildRecipientsText, formatDateTime } from "./table.helpers";

interface Column {
  id: string;
  label: string;

  align?: "left" | "center" | "right";
  minWidth?: number;
  maxWidth?: number;

  showInTabs?: NotificationTabKey[];

  isActions?: boolean;
  getValue?: (notification: INotification) => React.ReactNode;
}

export const COLUMNS: Column[] = [
  {
    id: "id",
    label: "ID",
    getValue: (n) => n.id,
  },
  {
    id: "title",
    label: "Título",
    getValue: (n) => n.title,
  },
  {
    id: "recipients",
    label: "Destinatários",
    maxWidth: 400,
    getValue: (n) => buildRecipientsText(n),
  },
  {
    id: "startAt",
    label: "Vigência inicial",
    minWidth: 115,
    getValue: (n) => formatDateTime(n.startAt),
  },
  {
    id: "endAt",
    label: "Vigência final",
    minWidth: 115,
    getValue: (n) => formatDateTime(n.endAt),
  },
  {
    id: "createdBy",
    label: "Criado por",
    getValue: (n) => n.createdBy,
  },
  {
    id: "createdAt",
    label: "Criado em",
    minWidth: 115,
    getValue: (n) => formatDateTime(n.createdAt),
  },
  {
    id: "deletedBy",
    label: "Excluído por",
    showInTabs: ["DELETED"],
    getValue: (n) => n.deletedBy || "-",
  },
  {
    id: "deletedAt",
    label: "Excluído em",
    showInTabs: ["DELETED"],
    getValue: (n) => formatDateTime(n.deletedAt),
  },
  {
    id: "action",
    label: "Ações",
    align: "center",
    isActions: true,
  },
];
